export default __webpack_public_path__ + "locales/pt-BR/InviteDialog.json?hash=cbc34bd9483547371da1f011bc60d590";